import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFlag = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.5 21C3.224 21 3 20.776 3 20.5V5.5C3 5.224 3.224 5 3.5 5C3.776 5 4 5.224 4 5.5V20.5C4 20.776 3.776 21 3.5 21V21Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.50019 12C5.39619 12 5.29019 11.967 5.20019 11.9C4.97919 11.734 4.93419 11.421 5.10019 11.2C5.16719 11.11 6.77619 9 9.00019 9C10.6942 9 11.8132 9.599 12.8012 10.127C13.6762 10.595 14.4322 11 15.5002 11C17.6922 11 19.2582 8.92 20.1502 7.282C19.4522 7.679 18.5602 8 17.5002 8C15.2932 8 14.1532 6.86 13.1462 5.854C12.1512 4.859 11.2922 4 9.50019 4C7.27619 4 5.91319 5.782 5.90019 5.8C5.73419 6.021 5.42119 6.066 5.20019 5.9C4.97919 5.734 4.93419 5.421 5.10019 5.2C5.16719 5.11 6.78119 3 9.50019 3C11.7072 3 12.8472 4.14 13.8542 5.146C14.8492 6.141 15.7082 7 17.5002 7C19.7242 7 21.0872 5.218 21.1002 5.2C21.2472 5.004 21.5152 4.943 21.7322 5.057C21.9492 5.171 22.0522 5.425 21.9742 5.658C21.9532 5.722 21.4412 7.239 20.4162 8.777C19.8042 9.695 19.1342 10.43 18.4252 10.962C17.5072 11.65 16.5232 11.999 15.5002 11.999C14.1822 11.999 13.2402 11.495 12.3292 11.008C11.3592 10.489 10.4432 9.999 9.00019 9.999C7.27019 9.999 5.91319 11.781 5.90019 11.799C5.80219 11.93 5.65219 11.999 5.50019 11.999V12Z'
    />
  </svg>
);
export default SvgFlag;
